// Löschen mit Rückgängig-Frist (Design-Runde 2): der Eintrag verschwindet sofort, der DELETE geht erst nach der Frist
// an die API. Verlässt man die Seite in der Frist (Neuladen, Tab schließen), würde das Löschen sonst verloren gehen und
// der Eintrag käme zurück (E2E-02). Deshalb merkt sich dieses Modul alle offenen Löschungen und schickt sie bei
// `pagehide` nach (fetch mit keepalive überlebt das Schließen der Seite). Bei Navigation innerhalb der App läuft der
// Zeitgeber ganz normal weiter.
type Offen = { pfad: string; abgeschickt: boolean };

const offene = new Set<Offen>();
let hoert = false;

function nachholen() {
  for (const o of offene) {
    if (o.abgeschickt) continue;
    o.abgeschickt = true;
    try {
      void fetch(o.pfad, { method: "DELETE", credentials: "same-origin", keepalive: true, headers: { Accept: "application/json" } });
    } catch {
      /* Seite wird ohnehin verlassen */
    }
  }
  offene.clear();
}

export type LoeschFrist = {
  /** Klick auf „Rückgängig“: Zeitgeber stoppen, nichts wird gelöscht. */
  rueckgaengig: () => void;
};

/**
 * Startet die Frist. `loeschen` ist der normale Weg (API-Aufruf mit Fehlerbehandlung), er läuft nach `fristMs`.
 * `pfad` ist die DELETE-Adresse für den Nachholweg beim Verlassen der Seite.
 */
export function loeschFristStarten(pfad: string, fristMs: number, loeschen: () => void): LoeschFrist {
  if (!hoert && typeof window !== "undefined") {
    hoert = true;
    window.addEventListener("pagehide", nachholen);
  }
  const eintrag: Offen = { pfad, abgeschickt: false };
  offene.add(eintrag);
  let storniert = false;
  const timer = window.setTimeout(() => {
    offene.delete(eintrag);
    if (storniert || eintrag.abgeschickt) return;
    loeschen();
  }, fristMs);
  return {
    rueckgaengig: () => {
      storniert = true;
      window.clearTimeout(timer);
      offene.delete(eintrag);
    },
  };
}
